/**
 * @ngdoc Service
 */
(function () {
    'use strict';

    angular.module('vrm.components')
        .service('VrmMapService', VrmMapService);


    /* @ngInject */
    function VrmMapService($log, WhitelabelService) {

        var supportedColors = ['blue', 'orange', 'black', 'red'];
        var colorValues = ['#387dc5', '#f0962e', '#000000', '#f35c58'];
        //TODO correct marker positions
        var spriteMarkerPosition = {
            blue: [52, 0],
            orange: [52, 72],
            black: [52, 144],
            red: [52, 216]
        };
        var spriteClusterMarkerPosition = {
            blue: [0, 0],
            orange: [0, 72],
            black: [0, 144],
            red: [0, 216]
        };

        //TODO use sprite-icons@2X.png on high resolution

        /* Public API */
        var service = {
            setCenterAndBoundsForCoordinatesList: setCenterAndBoundsForCoordinatesList,
            updateMarkers: updateMarkers,
            buildMarkerIcon: buildMarkerIcon,
            getMarkerColor: getMarkerColor,
            getShape: getShape,
            addResetZoomButton: addResetZoomButton,
            setCenter: setCenter,
            getCenterAndZoom: getCenterAndZoom,
            clusterOptions: {
                styles: supportedColors.map(function (color, index) {
                    return {
                        url: WhitelabelService.getMarkerSprite(),
                        width: 52,
                        height: 72,
                        backgroundPosition: '-' + spriteClusterMarkerPosition[color][0] + 'px -' + spriteClusterMarkerPosition[color][1] + 'px',
                        anchorIcon: [68, 26],
                        textColor: colorValues[index],
                        textSize: 21,
                        textAlign: 'center',
                        fontFamily: 'museo-sans,sans-serif;margin-top:-10px;margin-left:1px', // DvdG: Hack to align text properly
                        fontWeight: 'bold'
                    };
                }),
                calculator: clusterCalculator
            },
            setViewRestrictions: setViewRestrictions
        };

        //Base options for draw options
        var drawOptions = {
            strokeWeight: 0,
            fillOpacity: 0.45
        };

        return service;

        /* Private */

        function buildMarkerIcon(color) {
            return {
                anchor: new google.maps.Point(26, 68),
                origin: new google.maps.Point(
                    spriteMarkerPosition[color][0],
                    spriteMarkerPosition[color][1]
                ),
                size: new google.maps.Size(52, 72),
                url: WhitelabelService.getMarkerSprite()
            };
        }

        function getMarkerColor(marker) {
            if (!marker.owner) {
                return 'orange';
            } else {
                return marker.alarm ? 'red' : 'blue';
            }
        }

        function getMarkerClusterColorFunction(markers) {
            // Determine wheter there are any active alarms in this cluster
            var activeAlarms = false;
            var allViaDealer = true;
            for (var i = 0; i < markers.length; i++) {
                if (allViaDealer && markers[i].owner) {
                    allViaDealer = false;
                }
                if (!activeAlarms && markers[i].alarm) {
                    activeAlarms = true;
                    if (!allViaDealer) {
                        break;
                    }
                }
            }

            if (allViaDealer) {
                return 'orange';
            }

            return activeAlarms ? 'red' : 'blue';
        }

        function clusterCalculator(markers, numStyles) {
            // Return the setings for the cluster
            return {
                text: markers.length.toString(),
                index:
                    supportedColors.indexOf(
                        getMarkerClusterColorFunction(
                            markers.map(function (marker) {
                                return marker.model.data;
                            })
                        )
                    ) + 1,
                title: ""
            };
        }

        /**
         * Convert geofencedata to Google Maps shape
         * @param geofenceData
         * @returns {*}
         */
        function getShape(geofenceData, editable) {
            var shape = null;
            if (!geofenceData) {
                return null;
            }

            if (geofenceData.type == "rectangle") {
                var coords = geofenceData.coords;
                var northeast = coords.northeast;
                var southwest = coords.southwest;
                var bounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(southwest.lat, southwest.lng),
                    new google.maps.LatLng(northeast.lat, northeast.lng)
                );

                // Define a rectangle and set its editable property to true.
                shape = new google.maps.Rectangle(
                    _.extend(
                        {
                            bounds: bounds,
                            editable: editable
                        },
                        drawOptions
                    )
                );
            } else if (geofenceData.type == "circle") {
                shape = new google.maps.Circle(
                    _.extend(
                        {
                            center: new google.maps.LatLng(
                                geofenceData.center.lat,
                                geofenceData.center.lng
                            ),
                            radius: geofenceData.radius,
                            editable: editable
                        },
                        drawOptions
                    )
                );
            } else if (geofenceData.type == "polygon") {
                var coords = [];
                for (var i = 0; i < geofenceData.coords.length; i++) {
                    var coord = geofenceData.coords[i];
                    coords.push(new google.maps.LatLng(coord.lat, coord.lng));
                }

                shape = new google.maps.Polygon(
                    _.extend(
                        {
                            paths: coords,
                            type: google.maps.drawing.OverlayType.POLYGON,
                            editable: editable
                        },
                        drawOptions
                    )
                );
            }

            return shape;
        }

        /**
         * Update markers in a map model
         *
         * @param map
         * @param installations
         */
        function updateMarkers(map, installations) {
            // Clear existing markers
            map.markers.length = 0;

            // iterate over collection and add as marker
            _.each(installations, function (installation) {
                if (installation.extended !== false) {
                    var coords = {
                        latitude: installation.data.lt
                            ? installation.data.lt.rawValue
                            : 0,
                        longitude: installation.data.lg
                            ? installation.data.lg.rawValue
                            : 0
                    };
                } else {
                    var coords = {
                        latitude: 0,
                        longitude: 0
                    };
                }

                //Hide installations without location
                if (coords.latitude == 0 && coords.longitude == 0) {
                    return;
                }

                map.markers.push({
                    data: installation,
                    id: installation.idSite,
                    description: installation.name,
                    lastLogSecondsAgo: installation.last_timestamp,
                    runningOn: installation.device_icon,
                    status: installation.alarm,
                    show: false,
                    coords: coords,
                    icon: buildMarkerIcon(getMarkerColor(installation))
                });
            });
        }

        /**
         *  Helper function to get Average center and max bounds for list of coordinates (lat lng)
         *
         * @param map Array
         */
        function setCenterAndBoundsForCoordinatesList(map) {
            // Create a new viewpoint bound
            var bounds = new google.maps.LatLngBounds(),
                newBounds = new google.maps.LatLngBounds();

            // if site does not have any coords then
            if (map.markers.length > 0) {
                for (var i = 0; i < map.markers.length; i++) {
                    bounds.extend(
                        new google.maps.LatLng(
                            map.markers[i].coords.latitude,
                            map.markers[i].coords.longitude
                        )
                    );
                }
            }

            // If there are multiple markers then fit the map to the bounds of these markers
            if (map.markers.length > 1) {
                // We already have the bounds object and we could now pass it to the Google Map. However, the API keeps a big margin between the edge
                // of the canvas and the nearest marker. To avoid this we first have to narrow the bounds a bit.
                var northEast = bounds.getNorthEast(),
                    southWest = bounds.getSouthWest(),
                    center = bounds.getCenter(),
                    scaleLat = 10,
                    scaleLng = 10,
                    newNorthEastLat,
                    newNorthEastLng,
                    newSouthWestLat,
                    newSouthWestLng;

                // Calculate new coordinates for both outer corners
                newNorthEastLat =
                    northEast.lat() -
                    (northEast.lat() - center.lat()) / scaleLat;
                newNorthEastLng =
                    northEast.lng() -
                    (northEast.lng() - center.lng()) / scaleLng;

                newSouthWestLat =
                    southWest.lat() -
                    (southWest.lat() - center.lat()) / scaleLat;
                newSouthWestLng =
                    southWest.lng() -
                    (southWest.lng() - center.lng()) / scaleLng;

                // Create the new bounds object
                newBounds.extend(
                    new google.maps.LatLng(newNorthEastLat, newNorthEastLng)
                );
                newBounds.extend(
                    new google.maps.LatLng(newSouthWestLat, newSouthWestLng)
                );

                // Now finally pass the bounds object to the map.

                //This line makes it that the zoom options in every map controller are neglected (resets it) and it explains why we have the highest zoom by default

                map.control.getGMap().fitBounds(newBounds);
            } else {
                // Just center the map
                map.control.getGMap().setCenter(bounds.getCenter());
            }
        }

        function addResetZoomButton(map) {
            const gmap = map.control.getGMap();

            const controlButton = document.createElement("button");
            controlButton.classList.add("controlButton");

            const expandIcon = document.createElement("div");
            expandIcon.classList.add("expandIcon");
            controlButton.appendChild(expandIcon);
            controlButton.title = "Reset zoom level";
            controlButton.type = "button";

            controlButton.addEventListener("click", () => {
                gmap.setZoom(2);
            });

            const centerControlDiv = document.createElement("div");
            centerControlDiv.appendChild(controlButton);

            gmap.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(
                centerControlDiv
            );
        }
        //Set the center of the map manually
        function setCenter(map, center, zoomLevel) {
            const gmap = map.control.getGMap();
            gmap.setCenter(new google.maps.LatLng(center.lat, center.lng));
            gmap.setZoom(zoomLevel + 0);
        }

        function getCenterAndZoom(map) {
            const gmap = map.control.getGMap();
            const center = gmap.getCenter();
            const lat = center.lat();
            const lng = normalizeLongitude(center.lng());
            const zoom = gmap.getZoom();
            return { lat, lng, zoom };
        }

        function normalizeLongitude(lng) {
            if (lng > 180) {
                lng -= 360;
            } else if (lng < -180) {
                lng += 360;
            }
            return lng;
        }

        function getCenterAndZoom(map) {
            const gmap = map.control.getGMap();
            const center = gmap.getCenter();
            const lat = center.lat();
            const lng = normalizeLongitude(center.lng());
            const zoom = gmap.getZoom();
            return { lat, lng, zoom };
        }

        /**
         *
         * @param {*} map the map object from the scope
         *
         * Here we can set the options as in the Google maps api and not in the angular-ui api
         * It allows us to use more options for customisation (some are not available in the angular-ui constructor)
         *
         */
        function setViewRestrictions(map) {
            if (!map.control.getGMap) return;
            map.control.getGMap().setOptions({
                restriction: {
                    latLngBounds: {
                        north: 85,
                        south: -85,
                        west: -180,
                        east: 180
                    },
                    strictBounds: true
                },
                minZoom: 3
            });
        }
    }
})();
